import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  errorMessage: string = '';

  constructor(private router: Router) {}

  async login() {
    try {
      const response = await fetch('https://api.calobesidad.innsider.com.co/auth0/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password
        })
      });

      
      // Verificar si la respuesta es correcta
      if (!response.ok) {
        throw new Error('Error en la solicitud');
      }

      const data = await response.json();
      if (data.access_token) {
        // Almacenar el token en el local storage o donde sea necesario
        localStorage.setItem('access_token', data.access_token);
        this.router.navigate(['/home']); // Redirigir a /home
      } else {
        this.errorMessage = 'Login fallido. Intenta nuevamente.';
      }
    } catch (error) {
      this.errorMessage = 'Credenciales inválidas. Por favor intenta de nuevo.';
    }
  }
}
